import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { App, Workouts } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { metricConverter, metricUnit, useStateValue } from "../../config/AppContext";
import CatalogClass from "../../models/Catalog";

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    cursor: "pointer",
    "&:first-child .MuiTypography-body1": {
      borderTop: "none",
      paddingTop: 0,
    },
    "& .MuiTypography-body1": {
      fontSize: 12,
      fontWeight: 600,
      color: "#333333",
      borderTop: "2px solid #EEEEEE",
      paddingTop: "18px",
    },
    "& .MuiTypography-body2": {
      display: "block",
      fontSize: 12,
      color: "#9B9B9B",
      "& .Oval": {
        margin: "0 5px",
      },
    },
  },
}));

export const ExerciseSets: React.FC<{
  exercise: Workouts.IExercise;
  exerciseIndex?: number;
  supersetIndex?: number;
  setEditExercise?: React.Dispatch<
    React.SetStateAction<{
      exercise: Workouts.IExercise;
      exerciseIndex: number;
      supersetIndex: number;
    } | null>
  >;
}> = ({ exercise, exerciseIndex, supersetIndex, setEditExercise }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    if (!setEditExercise || exerciseIndex === undefined || supersetIndex === undefined) return;
    setEditExercise({ exercise, exerciseIndex, supersetIndex });
  };
  const min =
    exercise.score_vals.length > 0 && exercise.score_vals[0].value.length > 0
      ? Math.min(...exercise.score_vals[0].value)
      : 0;
  const max =
    exercise.score_vals.length > 0 && exercise.score_vals[0].value.length > 0
      ? Math.max(...exercise.score_vals[0].value)
      : 0;
  const { catalog, metric } = useStateValue() as {
    catalog: CatalogClass;
    metric: App.State["metric"];
  };
  const catalogExercise = catalog.findExercise(exercise.exercise_id);
  if (!catalogExercise) return <div></div>;
  const { name } = catalogExercise;
  const { score_count, score_type, score_vals } = exercise;
  const firsValueOfFirstScoreValue = score_vals[0] && score_vals[0] && score_vals[0].value[0];

  return (
    <Container className={classes.container} onClick={handleClick}>
      <Typography variant="body1" className="exercise-set name" noWrap>
        {name}
      </Typography>
      <Typography variant="body2" component="span">
        {score_count === 0 || (score_count === 1 && !firsValueOfFirstScoreValue) ? 0 : score_count}{" "}
        {t("Set")}
        {score_count > 1 ? "s" : ""}
        <span className="Oval" />
        {score_count === 1 ? (
          <>
            {metricConverter(min, score_type, metric)}{" "}
            {t(`${metricUnit(`${score_type}O`, metric)}`).toLowerCase()}
          </>
        ) : (
          <>
            {metricConverter(min, score_type, metric)} - {metricConverter(max, score_type, metric)}{" "}
            {t(`${metricUnit(`${score_type}O`, metric)}`).toLowerCase()}
          </>
        )}
      </Typography>
    </Container>
  );
};
export default ExerciseSets;
